import axios from "axios";
import * as URL from "../../helpers/Constants";

export default class PMSAdditionalBalanceServices {

    static getAllAdditionalBalancesByPharmacyId(params) {
        const {pharmacyId, ...rest} = params;
        return axios.get(`${URL.PMS_GET_ALL_ADDITIONAL_BALANCE_BY_PHARMACY_ID}/${pharmacyId}`, {
            ...PMSAdditionalBalanceServices.getAuthHeader(), params: rest,
        });
    }

    static createAdditionalBalance(pharmacyId, data) {
        return axios.post(`${URL.PMS_CREATE_ADDITIONAL_BALANCE}/${pharmacyId}`, data,
            PMSAdditionalBalanceServices.getAuthHeader()
        );
    }

    static updateAdditionalBalance(id, pharmacyId, data) {
        return axios.put(`${URL.PMS_UPDATE_ADDITIONAL_BALANCE}/${id}/${pharmacyId}`, data,
            PMSAdditionalBalanceServices.getAuthHeader()
        );
    }

    static deleteAdditionalBalance(id, pharmacyId) {
        return axios.post(`${URL.PMS_DELETE_ADDITIONAL_BALANCE}/${id}/${pharmacyId}`, {},
            PMSAdditionalBalanceServices.getAuthHeader()
        );
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        };
    }
}
